<template>
  <div class="overview" v-loading="loading">
    <el-row class="caption-row" :gutter="24">
      <el-card class="category-block">
        <div slot="header">订单信息</div>

        <el-col :xl="12" :md="12" :sm="12" :xs="12">
          <el-card shadow="never" class="caption">
            <div slot="header" class="caption-header"></div>
            <div class="caption-body" style="color: #ff3333">
              <div>
                <p>今日订单</p>
                <el-tooltip placement="top" effect="dark">
                  <div slot="content" v-text="systemInfo.inOrderNum"></div>
                  <div>
                    <span
                      style="overflow: hidden; text-overflow: ellipsis"
                      v-text="systemInfo.inOrderNum"
                    ></span>
                    <span class="unit" v-text="'单'"></span>
                  </div>
                </el-tooltip>
              </div>
              <div>
                <p>金额</p>
                <el-tooltip placement="top" effect="dark">
                  <div slot="content" v-text="systemInfo.inOrderAmount"></div>
                  <div>
                    <span
                      style="overflow: hidden; text-overflow: ellipsis"
                      v-text="getNumber(systemInfo.inOrderAmount)"
                    ></span>
                    <span
                      class="unit"
                      v-text="getUnitPrefix(systemInfo.inOrderAmount) + '元'"
                    ></span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col :xl="12" :md="12" :sm="12" :xs="12">
          <el-card shadow="never" class="caption">
            <div slot="header" class="caption-header"></div>
            <div class="caption-body" style="color: #ff3333">
              <div>
                <p>昨日订单</p>
                <el-tooltip placement="top" effect="dark">
                  <div
                    slot="content"
                    v-text="currentMonthInfo.inOrderNum"
                  ></div>
                  <div>
                    <span
                      style="overflow: hidden; text-overflow: ellipsis"
                      v-text="currentMonthInfo.inOrderNum"
                    ></span>
                    <span class="unit" v-text="'单'"></span>
                  </div>
                </el-tooltip>
              </div>
              <div>
                <p>金额</p>
                <el-tooltip placement="top" effect="dark">
                  <div
                    slot="content"
                    v-text="currentMonthInfo.inOrderAmount"
                  ></div>
                  <div>
                    <span
                      style="overflow: hidden; text-overflow: ellipsis"
                      v-text="getNumber(currentMonthInfo.inOrderAmount)"
                    ></span>
                    <span
                      class="unit"
                      v-text="
                        getUnitPrefix(currentMonthInfo.inOrderAmount) + '元'
                      "
                    ></span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col v-if="false" :xl="6" :md="6" :sm="6" :xs="6">
          <el-card shadow="never" class="caption">
            <div slot="header" class="caption-header"></div>
            <div class="caption-body" style="color: #ff3333">
              <div>
                <p>本年订单</p>
                <el-tooltip placement="top" effect="dark">
                  <div slot="content" v-text="currentYearInfo.inOrderNum"></div>
                  <div>
                    <span
                      style="overflow: hidden; text-overflow: ellipsis"
                      v-text="currentYearInfo.inOrderNum"
                    ></span>
                    <span class="unit" v-text="'单'"></span>
                  </div>
                </el-tooltip>
              </div>
              <div>
                <p>金额</p>
                <el-tooltip placement="top" effect="dark">
                  <div
                    slot="content"
                    v-text="currentYearInfo.inOrderAmount"
                  ></div>
                  <div>
                    <span
                      style="overflow: hidden; text-overflow: ellipsis"
                      v-text="getNumber(currentYearInfo.inOrderAmount)"
                    ></span>
                    <span
                      class="unit"
                      v-text="
                        getUnitPrefix(currentYearInfo.inOrderAmount) + '元'
                      "
                    ></span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </el-card>
        </el-col>

        <el-col v-if="false" :xl="6" :md="6" :sm="6" :xs="6">
          <el-card shadow="never" class="caption">
            <div slot="header" class="caption-header"></div>
            <div class="caption-body" style="color: #ff3333">
              <div>
                <p>全部订单</p>
                <el-tooltip placement="top" effect="dark">
                  <div slot="content" v-text="allOrderInfo.inOrderNum"></div>
                  <div>
                    <span
                      style="overflow: hidden; text-overflow: ellipsis"
                      v-text="allOrderInfo.inOrderNum"
                    ></span>
                    <span class="unit" v-text="'单'"></span>
                  </div>
                </el-tooltip>
              </div>
              <div>
                <p>金额</p>
                <el-tooltip placement="top" effect="dark">
                  <div slot="content" v-text="allOrderInfo.inOrderAmount"></div>
                  <div>
                    <span
                      style="overflow: hidden; text-overflow: ellipsis"
                      v-text="getNumber(allOrderInfo.inOrderAmount)"
                    ></span>
                    <span
                      class="unit"
                      v-text="getUnitPrefix(allOrderInfo.inOrderAmount) + '元'"
                    ></span>
                  </div>
                </el-tooltip>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-card>

      <el-row class="overview-header">
        <span>每日更新数据</span>
        <span class="header-tip"
          >数据起止时间：00:00:00 -- {{ getTime() }}</span
        >
      </el-row>
      <el-card class="category-block">
        <div slot="header">申报信息</div>
        <el-col :xl="6" :md="6" :sm="12" :xs="24" class="br-r">
          <el-card shadow="never" class="caption">
            <div slot="header" class="caption-header">
              <span>未申报订单</span>
            </div>
            <div class="caption-body" v-text="systemInfo.notDeclareNum"></div>
            <div class="caption-footer">单位：单</div>
          </el-card>
        </el-col>
        <el-col :xl="6" :md="6" :sm="12" :xs="24" class="br-t">
          <el-card shadow="never" class="caption">
            <div slot="header" class="caption-header">
              <span>申报中的订单</span>
            </div>
            <div class="caption-body" v-text="systemInfo.declareNum"></div>
            <div class="caption-footer">单位：单</div>
          </el-card>
        </el-col>
        <el-col :xl="6" :md="6" :sm="12" :xs="24" class="br-t">
          <el-card shadow="never" class="caption border-none">
            <div slot="header" class="caption-header">
              <span>申报成功</span>
            </div>
            <div
              class="caption-body"
              v-text="systemInfo.declareSuccessNum"
            ></div>
            <div class="caption-footer">单位：单</div>
          </el-card>
        </el-col>
        <el-col :xl="6" :md="6" :sm="12" :xs="24" class="br-t">
          <el-card shadow="never" class="caption border-none">
            <div slot="header" class="caption-header">
              <span>申报失败</span>
            </div>
            <div
              class="caption-body"
              v-text="systemInfo.declareNum - systemInfo.declareSuccessNum"
            ></div>
            <div class="caption-footer">单位：单</div>
          </el-card>
        </el-col>
      </el-card>

      <el-card class="category-block">
        <div slot="header">仓库信息</div>
        <el-col :xl="6" :md="6" :sm="12" :xs="24" class="br-t">
          <el-card shadow="never" class="caption border-none">
            <div slot="header" class="caption-header">
              <span>推送仓库</span>
            </div>
            <div class="caption-body" v-text="systemInfo.sendWmsNum"></div>
            <div class="caption-footer">单位：单</div>
          </el-card>
        </el-col>
        <el-col :xl="6" :md="6" :sm="12" :xs="24" class="br-t">
          <el-card shadow="never" class="caption border-none">
            <div slot="header" class="caption-header">
              <span>已发货</span>
            </div>
            <div class="caption-body" v-text="systemInfo.wmsShipped"></div>
            <div class="caption-footer">单位：单</div>
          </el-card>
        </el-col>
      </el-card>

      <el-card class="category-block">
        <div slot="header">关注事项</div>
        <el-col
          :xl="6"
          :md="12"
          :sm="12"
          :xs="24"
          class="br-t"
          v-if="taxAccount.length > 0"
        >
          <el-card shadow="never" class="caption border-none">
            <div slot="header" class="caption-header">
              <span>税金账户余额</span>
            </div>
            <div class="caption-body">
              <ul>
                <li :key="index" v-for="(ta, index) in taxAccount">
                  <div>{{ ta.enterpriseCustomsName }}</div>
                  <div>{{ ta.taxBalance / 100 }}</div>
                </li>
              </ul>
            </div>
          </el-card>
        </el-col>
      </el-card>
    </el-row>
  </div>
</template>

<script>
import { formatDate } from "@/utils/common";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      loading: false,
      systemInfo: {},
      currentMonthInfo: {},
      currentYearInfo: {},
      allOrderInfo: {},
      taxAccount: [],
    };
  },
  activated() {
    let currentDate = new Date();
    this.queryOverviewResult(
      formatDate(currentDate, "yyyy-MM-dd") + " 00:00:00",
      formatDate(currentDate)
    ).then((res) => {
      this.systemInfo = res.systemRunInfo || {};
    });
    let currentMonthLastDate = formatDate(
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() + 1,
        0,
        23,
        59,
        59
      )
    );
    this.queryOverviewResult(
      formatDate(currentDate - 24 * 1000 * 60 * 60, "yyyy-MM-dd") + " 00:00:00",
      formatDate(currentDate - 24 * 1000 * 60 * 60, "yyyy-MM-dd") + " 23:59:59"
    ).then((res) => {
      this.currentMonthInfo = res.systemRunInfo || {};
    });
    // this.queryOverviewResult(
    //   formatDate(new Date(), "yyyy-01-01") + " 00:00:00",
    //   formatDate(new Date(), "yyyy-12-31") + " 23:59:59"
    // ).then((res) => {
    //   this.currentYearInfo = res.systemRunInfo || {};
    // });

    // this.queryOverviewResult(
    //   "2019-01-01 00:00:00",
    //   formatDate(new Date(), "yyyy-MM-dd") + " 23:59:59"
    // ).then((res) => {
    //   this.allOrderInfo = res.systemRunInfo || {};
    // });

    this.queryPageExt({
      request: {
        pageIndex: 1,
        pageSize: 100,
      },
    }).then((res) => {
      this.taxAccount = res.taxAccountEntities;
    });
  },
  created() {},
  methods: {
    ...mapActions({
      systemRunInfo: "systemRunInfo",
      queryPageExt: "ta/pageQuery",
    }),
    async queryOverviewResult(startDate, endDate) {
      this.loading = true;
      return this.systemRunInfo({
        request: JSON.stringify({
          startDate: startDate,
          endDate: endDate,
        }),
      }).then((res) => {
        this.loading = false;
        return Promise.resolve(res);
      });
    },
    getTime() {
      return formatDate(new Date(), "hh:mm:ss");
    },
    toLocaleString(num) {
      if (num) {
        return parseFloat(num.toFixed(2)).toLocaleString();
      } else {
        return num;
      }
    },
    getUnitAndNumber(number) {
      let flag = 0;
      let num = number;
      let unit = "";
      do {
        if (num < 10000) {
          break;
        }
        if (num < 100000000) {
          unit = "万";
          num /= 10000;
          break;
        }
        if (num < 1000000000000) {
          unit = "亿";
          num /= 100000000;
          break;
        }
        // eslint-disable-next-line no-constant-condition
      } while (false);
      num = num.toFixed(4);
      let dotIndex = 0;
      if ((dotIndex = num.indexOf(".")) !== -1) {
        let dotZeroFlag = true;
        for (let i = dotIndex + 1; i < num.length; i++) {
          let tempNum = num.charAt(i);
          if (tempNum !== "0") {
            dotZeroFlag = false;
            break;
          }
        }
        if (dotZeroFlag) {
          num = num.substring(0, dotIndex);
        }
      }
      if (num.length > 4) {
        num = num.substring(0, 4);
        if (num.charAt(num.length - 1) === ".") {
          num = num.substring(0, num.length - 1);
        }
      }
      return { num, unit };
    },
    getUnitPrefix(number) {
      if (number == null) {
        return "";
      }
      return this.getUnitAndNumber(number).unit;
    },
    getNumber(number) {
      if (number == null) {
        return 0;
      }
      return this.getUnitAndNumber(number).num;
    },
  },
  computed: {
    totalDCSalesOrderPriceSub() {
      return this.totalDCSalesOrderPrice.toFixed(2).split(".")[1];
    },
  },
};
</script>

<style lang="scss">
.overview {
  border: 0;

  .overview-header {
    text-align: left;
    line-height: 40px;
    color: #8a9199;
    font-size: 14px;
  }

  .header-tip {
    margin-left: 10px;
  }

  .el-card.category-block {
    background-color: #f8f8f8;
    margin-bottom: 10px;
  }

  .el-card.caption {
    border: 0;
    border-radius: 8px;
    margin-bottom: 24px;

    &.border-none {
      border: 0;
    }

    .el-card__header {
      border-bottom: 0;
      border-top: 8px solid #3399ff;
      padding: 9px 24px;
      white-space: nowrap;
    }

    .el-card__body {
      padding: 16px 24px;
    }
  }

  .caption-header {
    color: #17181a;
    font-size: 18px;
    font-family: PingFang-SC-Medium;
    text-align: left;
    font-weight: normal;
  }

  .caption-body {
    display: flex;
    -webkit-box-pack: center;
    justify-content: flex-start;
    text-align: left;
    font-size: 28px;
    font-weight: bold;
    font-family: PingFang-SC;
    align-items: baseline;

    ul {
      &::-webkit-scrollbar {
        display: none;
      }
      height: 60px;
      overflow: auto;
      width: 100%;
      list-style: none;
      margin: 0;
      padding: 0;
      li {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
      }
    }
    & > div {
      width: 100%;

      & > p {
        font-size: 16px;
        margin: 6px auto 16px auto;
        color: #4d4d4d;
      }

      .unit {
        font-size: 12px;
        color: #a7a7a7;
        margin-left: 6px;
      }
    }

    sub {
      font-size: 14px;
    }
  }

  .caption-footer {
    color: #8a9199;
    font-size: 14px;
    text-align: right;
  }
}
</style>
